/** Compact stat format for the narrow S/R/V bottom stats bars: 1350 → '1.4k', 12000 → '12k',
 * 1200000 → '1.2M'. Values under 1000 render as-is. Display-only (rounds to 1 decimal, strips a
 * trailing .0). */
const abbreviateStatNumber = (value) => {
  const n = Number(value) || 0;
  const abs = Math.abs(n);
  if (abs < 1000) return `${n}`;
  const fmt = (divisor, suffix) => `${(n / divisor).toFixed(1).replace(/\.0$/, '')}${suffix}`;
  return abs < 1000000 ? fmt(1000, 'k') : fmt(1000000, 'M');
};

export default abbreviateStatNumber;
